var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var Projects = function Projects(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.293 2.293a1 1 0 0 1 1.414 0L12 6.586l3.293-3.293a3.828 3.828 0 1 1 5.414 5.414L17.414 12l4.293 4.293a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0L12 17.414l-4.293 4.293A1 1 0 0 1 7 22H3a1 1 0 0 1-1-1v-4a1 1 0 0 1 .293-.707L6.586 12 2.293 7.707a1 1 0 0 1 0-1.414l4-4ZM15.914 18.5l.793-.793a1 1 0 0 0-1.414-1.414l-.793.793L13.414 16 16 13.414 19.586 17 17 19.586 15.914 18.5Zm-.621-7.207-4 4L6.586 20H4v-2.586l10.5-10.5L17.086 9.5l-1.793 1.793ZM6.914 9.5l.793-.793a1 1 0 0 0-1.414-1.414l-.793.793L4.414 7 7 4.414 10.586 8 8 10.586 6.914 9.5ZM18.5 8.086l.793-.793a1.828 1.828 0 0 0-2.586-2.586l-.793.793L18.5 8.086Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default Projects;